module.exports = __webpack_public_path__ + "img/lowcredits-arrow.d40a1bae.svg";